import React from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Close from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import style from "./modal.module.scss";
import { useSpring, animated } from 'react-spring';

const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

export default function SimpleModal({ open, children, handleClose = () => { } }) {

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={style.modal}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                style: {
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                },
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <IconButton
                    classes={{root: style.iconButton}}
                    onClick={handleClose}
                    >
                    <Close />
                </IconButton>
                {children}
            </Fade>
        </Modal>
    );
}